// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Settings */
html {
  font-family: 'Roboto', sans-serif;
  line-height: 1.6;
  background-color: #f4f7fb;
  color: #333;
}

h1 {
  font-size: 2.5em;
  color: #4A90E2;
  margin: 20px 0;
}

p {
  line-height: 1.8em;
  margin: 0 0 16px 0;
}

.quiz {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding: 20px;
}

/* Button Styling */
button {
  background: linear-gradient(145deg, #f3f3f3, #e2e2e2);
  border: none;
  padding: 12px 30px;
  cursor: pointer;
  border-radius: 8px;
  font-weight: 600;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
}

button:hover {
  background: linear-gradient(145deg, #e2e2e2, #f3f3f3);
  transform: translateY(-2px);
}

button:active {
  transform: translateY(1px);
}

button.next {
  background: linear-gradient(145deg, #6ad85c, #5abc4e);
  border-bottom: 4px solid #4f9e42;
}

button.start,
button.restart {
  margin-top: 20px;
  background: linear-gradient(145deg, #ff9800, #f57c00);
  border-bottom: 4px solid #e65100;
}

/* Layout and Responsiveness */
@media only screen and (min-width: 1024px) {

  .answers,
  .vote-answers {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;
    padding-left: 15%;
    padding-right: 15%;
  }

  .progressBar {
    width: 70%;
  }
}

.question {
  width: 100%;
}

.questionText {
  font-size: 1.4em;
  font-weight: 500;
  margin: 20px 0;
  color: #333;
}

/* Answer Style */
.answer {
  height: 3em;
  padding: 10px;
  text-align: center;
  background: #f4f7fb;
  margin-bottom: 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.3s ease;
}

.answer:hover {
  background: #eaeaea;
  transform: scale(1.03);
}

.answer.selected {
  background: #c8c8c8;
}

.answer.correct {
  background: #6ad85c;
  font-weight: bold;
  transform: scale(1.05);
}

.answer.incorrect {
  background: #df3636;
  font-weight: bold;
  transform: scale(1.05);
}

/* Progress Bar Styling */
.progressBar {
  width: 100%;
  background: #eaeaea;
  height: 18px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.progressBar .inner {
  background: #6ad85c;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  transition: width 0.5s ease;
  border-radius: 8px;
}

.progressBar .text {
  font-size: 0.8em;
  position: absolute;
  z-index: 10;
  color: #fff;
  font-weight: 600;
  padding: 0 10px;
}

/* Modernize the layout on larger screens */
@media only screen and (min-width: 768px) {
  .quiz {
    width: 80%;
  }
}`, "",{"version":3,"sources":["webpack://./src/quiz.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,iCAAiC;EACjC,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,gCAAgC;AAClC;;AAEA;;EAEE,gBAAgB;EAChB,qDAAqD;EACrD,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;;EAEE;;IAEE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":["/* Global Settings */\nhtml {\n  font-family: 'Roboto', sans-serif;\n  line-height: 1.6;\n  background-color: #f4f7fb;\n  color: #333;\n}\n\nh1 {\n  font-size: 2.5em;\n  color: #4A90E2;\n  margin: 20px 0;\n}\n\np {\n  line-height: 1.8em;\n  margin: 0 0 16px 0;\n}\n\n.quiz {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  width: 100%;\n  max-width: 1200px;\n  margin: auto;\n  padding: 20px;\n}\n\n/* Button Styling */\nbutton {\n  background: linear-gradient(145deg, #f3f3f3, #e2e2e2);\n  border: none;\n  padding: 12px 30px;\n  cursor: pointer;\n  border-radius: 8px;\n  font-weight: 600;\n  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease-in-out;\n}\n\nbutton:hover {\n  background: linear-gradient(145deg, #e2e2e2, #f3f3f3);\n  transform: translateY(-2px);\n}\n\nbutton:active {\n  transform: translateY(1px);\n}\n\nbutton.next {\n  background: linear-gradient(145deg, #6ad85c, #5abc4e);\n  border-bottom: 4px solid #4f9e42;\n}\n\nbutton.start,\nbutton.restart {\n  margin-top: 20px;\n  background: linear-gradient(145deg, #ff9800, #f57c00);\n  border-bottom: 4px solid #e65100;\n}\n\n/* Layout and Responsiveness */\n@media only screen and (min-width: 1024px) {\n\n  .answers,\n  .vote-answers {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n    margin-bottom: 20px;\n    padding-left: 15%;\n    padding-right: 15%;\n  }\n\n  .progressBar {\n    width: 70%;\n  }\n}\n\n.question {\n  width: 100%;\n}\n\n.questionText {\n  font-size: 1.4em;\n  font-weight: 500;\n  margin: 20px 0;\n  color: #333;\n}\n\n/* Answer Style */\n.answer {\n  height: 3em;\n  padding: 10px;\n  text-align: center;\n  background: #f4f7fb;\n  margin-bottom: 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.3s ease, transform 0.3s ease;\n}\n\n.answer:hover {\n  background: #eaeaea;\n  transform: scale(1.03);\n}\n\n.answer.selected {\n  background: #c8c8c8;\n}\n\n.answer.correct {\n  background: #6ad85c;\n  font-weight: bold;\n  transform: scale(1.05);\n}\n\n.answer.incorrect {\n  background: #df3636;\n  font-weight: bold;\n  transform: scale(1.05);\n}\n\n/* Progress Bar Styling */\n.progressBar {\n  width: 100%;\n  background: #eaeaea;\n  height: 18px;\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.progressBar .inner {\n  background: #6ad85c;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition: width 0.5s ease;\n  border-radius: 8px;\n}\n\n.progressBar .text {\n  font-size: 0.8em;\n  position: absolute;\n  z-index: 10;\n  color: #fff;\n  font-weight: 600;\n  padding: 0 10px;\n}\n\n/* Modernize the layout on larger screens */\n@media only screen and (min-width: 768px) {\n  .quiz {\n    width: 80%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
